export function createItemWidthCalculator({ getPageWidth, getNavWidth, ellipsisWidth, }) {
    return function itemWidthCalculator({ type, page }) {
        if (type === 'page' || type === 'active') {
            return getPageWidth(page.toString(), type === 'active');
        }
        if (type === '<' || type === '>') {
            return getNavWidth(type, page !== undefined);
        }
        if (type === '…L' || type === '…R') {
            return ellipsisWidth;
        }
        const _exCheck = type;
        return _exCheck;
    };
}
